import { render, staticRenderFns } from "./addproductBinding.vue?vue&type=template&id=1b11779f&"
import script from "./addproductBinding.vue?vue&type=script&lang=js&"
export * from "./addproductBinding.vue?vue&type=script&lang=js&"
import style0 from "./addproductBinding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b11779f')) {
      api.createRecord('1b11779f', component.options)
    } else {
      api.reload('1b11779f', component.options)
    }
    module.hot.accept("./addproductBinding.vue?vue&type=template&id=1b11779f&", function () {
      api.rerender('1b11779f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/backhaul/components/components/addproductBinding.vue"
export default component.exports